import React from 'react';
import { DropdownType } from '../types/DropdownType';
import styles from '../Dropdown.module.scss';
// @ts-ignore
import classNames from 'classnames';
import { useDropdownContext } from '../context/DropdownContext';

type DropdownListItemPropsType = {
  id?: string;
  className?: string;
  /**
   * Just a callback
   */
  onClick: () => void;
};

const DropdownListItem = (props: DropdownType & DropdownListItemPropsType) => {
  const { toggle } = useDropdownContext();

  const handleOnClick = () => {
    if (toggle) {
      toggle();
    }
    props.onClick();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLLIElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleOnClick();
      e.preventDefault();
    }
  };

  return (
    <li
      id={props.id}
      className={classNames(styles.dropdownListItem, props.className)}
      onClick={handleOnClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
    >
      {props.children}
    </li>
  );
};

export default React.memo(DropdownListItem);
